import {
  Directive,
  ElementRef,
  Input,
  HostListener,
  AfterViewInit
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

export interface FormGroupWithName extends UntypedFormGroup {
  formName: string;
}

@Directive({
  selector: '[abScrollInvalid]'
})
export class ScrollInvalidDirective implements AfterViewInit {
  @Input() formGroup: UntypedFormGroup;
  @Input('abScrollInvalid') formName: string;
  @Input() scrollPriority: string;

  public isInvalid = false;

  constructor(private elementRef: ElementRef) {}

  ngAfterViewInit() {
    if (this.formName) {
      (this.formGroup as FormGroupWithName).formName = this.formName;
    }
  }

  scrollToInvalidElement(name?: string) {
    if (name && name !== this.formName) {
      return;
    }

    const invalidElement = Array.from<any>(
      this.elementRef.nativeElement.querySelectorAll('.ng-invalid')
    ).filter(
      e =>
        e.matches('[type="text"]') ||
        e.matches('textarea') ||
        e.matches('mat-select')
    );

    if (invalidElement && invalidElement.length) {
      window.scrollTo({
        left: 0,
        top:
          invalidElement[0].getBoundingClientRect().top + window.scrollY - 200
      });

      invalidElement[0].focus();

      this.isInvalid = true;
    } else {
      this.isInvalid = false;
    }
  }

  @HostListener('submit', ['$event'])
  onSubmit(event) {
    event.preventDefault();

    if (this.formGroup.invalid && !this.formName) {
      this.scrollToInvalidElement();
    }
  }
}
